import moment from "moment";

// check employee joined earlier or later than filter date
const checkEmployeeJoined = (joinedDate, filterDate) => {
    const joiningDate = moment(joinedDate);
    const filteredDate = moment(filterDate);

    if (joiningDate.isBefore(filteredDate) || joiningDate.isSame(filteredDate)) {
        return true;
    }
    else{
        return false;
    }
}


const checkWeekend = (date, isHoliday) => {
    if (moment(date).day() === 6 || moment(date).day() === 0) {
        return true;
    } else {
        return isHoliday ? true : false;
    }
};

const checkWeekendDay = (date, isHoliday) => {
    return `(${moment(date).format('Do MMM, YYYY')}) is ${isHoliday ? isHoliday.name : moment(date).format('dddd')}.`;
};


export { checkEmployeeJoined, checkWeekend, checkWeekendDay};